import type { ToolUIPart } from 'ai';

import { GeneratedFilesList } from './process-files-tool';

interface ToolInvocationPart {
  type: string;
  state?: string;
  toolCallId?: string;
  output?: {
    generatedFileUuids?: string[];
  };
}

interface FillSl1FormToolProps {
  part: ToolUIPart;
}

/**
 * Component for rendering fillSl1Form tool output.
 */
export function FillSl1FormTool({ part }: FillSl1FormToolProps) {
  if (part.state === 'output-available' && (part as ToolInvocationPart).output) {
    const output = (part as ToolInvocationPart).output!;
    if (output.generatedFileUuids) {
      return (
        <GeneratedFilesList
          files={output.generatedFileUuids.map((uuid, idx) => ({ uuid, filename: `SL1 form ${idx + 1}.pdf` }))}
        />
      );
    }
  }

  return null;
}
